import React from "react";
import styled, { withTheme } from "styled-components";
import { UserStatus } from "./AccountStatus.constants";

const IconStyled = styled.i`
  color: ${(props) => getIconColor(props.status)};
  margin-right: 10px;
`;

const getIconColor = (status) => {
  switch (status) {
    case UserStatus.BLOCKED.id:
      return (props) => props.theme.cardinal;
    case UserStatus.LOCKED.id:
      return "black";
    case UserStatus.INVITED.id:
      return (props) => props.theme.brightSun;
    default:
      return (props) => props.theme.yellowGreen;
  }
};

const AccountStatus = (props) => {
  const { children } = props;

  const getAccountStatus = (status) => {
    const key = Object.keys(UserStatus).filter(
      (key) => UserStatus[key].id === status
    );
    return UserStatus[key]?.value;
  };

  const getIconClass = (status) => {
    switch (status) {
      case UserStatus.BLOCKED.id:
        return "fas fa-user-times";
      case UserStatus.LOCKED.id:
        return "fas fa-user-lock";
      case UserStatus.INVITED.id:
        return "fas fa-user-clock";
      default:
        return "fas fa-user-check";
    }
  };

  return (
    <span data-testid="accountStatus">
      <>
        <IconStyled className={getIconClass(children)} status={children} />
        {getAccountStatus(children)}
      </>
    </span>
  );
};

export default withTheme(AccountStatus);
